export enum WindowKeyListener {
  ClaimantMatching = 'M',
  PayeeMatching = 'P',
  KeyP = 'KeyP',
  KeyH = 'KeyH',
  KeyO = 'KeyO',
  KeyA = 'KeyA',
}
